<template>
	<div>
		<files :payload="{ resource_id: payload.resource_id, resource_type: payload.resource_type, show_checkboxes: false }"></files>
	</div>
</template>
<script>
	import Files from '@/components/Files'
	export default {
		name: 'files-modal',
		props: ['payload'],
		components: {
			Files
		}
	}
</script>